import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'jalali-moment';

import { _post } from '../../../utils/network';
import { commafy } from '../../../utils/methods';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';
import ListTable from '../../../components/List/ListTable/ListTable.component';
import Pagination from '../../../components/List/Pagination/Pagination.component';

const TransactionsList = () => {
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('transactions'), link: '/transactions-list' },
		{ title: t('list') }
	];

	const [transactions, setTransactions] = useState([]);
	let transactionsListData = {
		head: [t('creation_date'), t('user'), t('amount'), t('type'), t('category'), t('description')],
		body: transactions.map(transaction => [
			moment(transaction.create_date.substring(0, 10), 'YYYY-MM-DD').locale('fa').format('jYYYY/jMM/jDD'),
			<Link className='' to={`/users-edit/${transaction.user_id_information.user_id}`} target="_blank">
				{transaction.user_id_information.user_fullname}
			</Link>,
			<span className={transaction.transaction_amount < 0 ? 'text-danger' : 'text-success'}>
				{commafy(transaction.transaction_amount)}
			</span>,
			!!transaction.transaction_type ? t('score2_name') : t('score1_name'),
			transaction.transactioncategory_id_information.transactioncategory_name,
			transaction.transaction_description
		]),
		directions: ['ltr', 'rtl', 'ltr', '', 'rtl', 'rtl']
	};
	const [pageNumber, setPageNumber] = useState(1);
	const [pageCounter] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [pagesCount, setPagesCount] = useState(0);
	const [searchTransactionCategory, setSearchTransactionCategory] = useState(null);
	const [searchTransactionType, setSearchTransactionType] = useState(null);
	const [searchButtonIsLoading, setSearchButtonIsLoading] = useState(false);
	const [searchCounter, setSearchCounter] = useState(0);
	const getTransactions = async () => {
		let body = {
			user_id: null,
			transaction_type: searchTransactionType,
			transactioncategory_id: searchTransactionCategory,
			page: pageNumber,
			count: pageCounter
		};
		setSearchButtonIsLoading(true);
		let response = await _post('/transactions/admin/getAll', body);
		setSearchButtonIsLoading(false);
		switch(response.code){
			case 200:
				setTotalCount(response.data.all_transactions);
				setTransactions(response.data.transactions);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};
	
	const filterTransactions = event => {
		event.preventDefault();
		if(searchButtonIsLoading)
			return 0;
		let category = event.target.searchTransactionCategory.value.trim() || null;
		let type = event.target.searchTransactionType.value.trim() || null;
		setSearchTransactionCategory(category);
		setSearchTransactionType(type);
		if(pageNumber === 1)
			setSearchCounter(searchCounter + 1);
		else
			setPageNumber(1);
	};

	const transactionTypesList = [
		{ key: t('score1_name'), value: 0 },
		{ key: t('score2_name'), value: 1 }
	];
	
	const [transactionCategories, setTransactionCategories] = useState([]);
	const getTransactionCategories = async () => {
		let body = {
			transactioncategory_name: null,
			page: 1,
			count: 1000000
		};
		let response = await _post('/transactioncategories/admin/getAll', body);
		switch(response.code){
			case 200:
				setTransactionCategories(response.data.transactioncategories.map(item => {
					return {
						key: item.transactioncategory_name,
						value: item.transactioncategory_id
					}
				}));
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};

	useEffect(() => {
		getTransactionCategories();
	}, []);

	useEffect(() => {
		setPagesCount(Math.ceil(totalCount / pageCounter));
	}, [totalCount]);
	
	useEffect(() => {
		setSearchCounter(searchCounter + 1);
	}, [pageNumber]);

	useEffect(() => {
		getTransactions();
	}, [searchCounter]);
	
	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t('search_for')} {t('transactions')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={filterTransactions}>
						<div className="row gx-2">
							<FormField type="select" fieldKey="searchTransactionCategory" title={t('category')} value={searchTransactionCategory} selectItems={transactionCategories} isSearch={true} />
							<FormField type="select" fieldKey="searchTransactionType" title={t('type')} value={searchTransactionType} selectItems={transactionTypesList} isSearch={true} />
						</div>
						<div>
							<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={searchButtonIsLoading}>
								<i className="fa fa-search"></i> {t('search')}
							</LoadingButton>
						</div>
					</form>
				</div>
			</div>
			<ListTable title={t('transactions')} pageNumber={pageNumber} pageCounter={pageCounter} totalCount={totalCount} data={transactionsListData} />
			<Pagination pagesCount={pagesCount} action={setPageNumber} />
		</>
	);
};

export default TransactionsList;
